import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createRequestData, URL } from "./utils";

export const statsApi = createApi({
  reducerPath: "stats",
  baseQuery: fetchBaseQuery({
    baseUrl: `${URL.url}`,
    fetchFn: async (...args) => {
      return fetch(...args);
    },
  }),
  tagTypes: ["Stats"],
  endpoints: (builder) => ({
    getDashboardStats: builder.query({
      query: (data) => {
        const { token, ...filteredData } = data;
        const requestData = createRequestData({
          ...filteredData,
        });
        return {
          url: "/api/dashboard/stats",
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: {
            ...requestData,
          },
        };
      },
      providesTags: ["Stats"],
    }),
  }),
});

export const { useGetDashboardStatsQuery } = statsApi;
